import appConfig from "appConfig";

async function getTeamStatsAggregated(team_code, gender, accessToken) {
  const url = `${appConfig.apiBaseUrl}/GetTeamStatsAggregated?team_code=${encodeURIComponent(
    team_code
  )}&gender=${encodeURIComponent(gender)}`;

  const response = await fetch(url, {
    method: "GET",
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`
    }
  });

  if (!response.ok) {
    throw new Error(
      "Failed to fetch team stats aggregated: " + response.statusText
    );
  }

  return response.json();
}

export default getTeamStatsAggregated;
